export default __webpack_public_path__ + "static/media/bloodforaid4.9905d08e.png";